<!-- Riga legale discreta per le pagine senza footer (#818): area utente,
     configuratore, preventivi. Le Linee guida cookie del Garante (10/06/2021)
     chiedono che la scelta sui cookie si possa cambiare in ogni momento da
     ogni pagina: «Impostazioni cookie» riapre le preferenze del banner
     (CookieConsentBanner, montato in App.vue) con lo stesso evento del footer.
     I documenti si aprono in una nuova scheda, così non si perde il modulo o
     lo step in corso. -->
<template>
  <nav class="ic-legal-mini" :class="`ic-legal-mini--${align}`" aria-label="Note legali" data-testid="legal-mini-links">
    <button type="button" class="ic-legal-mini__link" data-testid="legal-mini-cookie" @click="openCookieSettings">
      Impostazioni cookie
    </button>
    <span class="ic-legal-mini__sep" aria-hidden="true">·</span>
    <a class="ic-legal-mini__link" data-testid="legal-mini-privacy" :href="privacyPath" target="_blank" rel="noopener">Privacy</a>
    <span class="ic-legal-mini__sep" aria-hidden="true">·</span>
    <a class="ic-legal-mini__link" data-testid="legal-mini-terms" :href="termsPath" target="_blank" rel="noopener">Condizioni d'uso</a>
  </nav>
</template>

<script>
import { LEGAL_PATHS } from '@/consent/legalDocuments.js';

const OPEN_COOKIE_PREFERENCES_EVENT = 'ic:open-cookie-preferences';

export default {
  name: 'LegalMiniLinks',
  props: {
    // 'center' (default) o 'left'.
    align: { type: String, default: 'center' },
  },
  data() {
    return { privacyPath: LEGAL_PATHS.privacy, termsPath: LEGAL_PATHS.termini };
  },
  methods: {
    openCookieSettings() {
      window.dispatchEvent(new CustomEvent(OPEN_COOKIE_PREFERENCES_EVENT));
    },
  },
};
</script>

<style scoped>
.ic-legal-mini {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 2px 6px;
  font-family: 'Raleway', ui-sans-serif, system-ui, sans-serif;
  font-size: 12px;
  line-height: 1.5;
  color: #7a7a7a;
}
.ic-legal-mini--left {
  justify-content: flex-start;
}
.ic-legal-mini__link {
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}
.ic-legal-mini__link:hover,
.ic-legal-mini__link:focus-visible {
  color: #489b79;
  text-decoration: underline;
}
.ic-legal-mini__sep {
  color: #b5b0a6;
}
</style>
